export class InternalError extends Error {
    constructor(readonly title: string, readonly message: string) {
        super(message);
    }
}